var TooltipShowTrigger = {
    MANUAL: "manual",
    MOUSEOVER: "mouseover",
    CLICK: "click"
};
Object.freeze(TooltipShowTrigger);

var TooltipType = {
    DEFAULT: "default",
    HELP: "help",
    ERROR: "error",
    CONTAINER: "container"
};
Object.freeze(TooltipType);

export default {
    TooltipShowTrigger: TooltipShowTrigger,
    TooltipType: TooltipType
};